export default "__VITE_ASSET__RPnL91dO__"